import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography,
    Box,
} from '@mui/material';

const BroadcastDialog = ({
    open,
    onClose,
    title,
    setTitle,
    message,
    setMessage,
    onSend,
    sending,
}) => {
    const handleSendClick = () => {
        onSend();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
            <DialogTitle
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: '20px',
                    lineHeight: '28px',
                    fontWeight: '500',
                    color: '#0C3466',
                    mb: 1,
                }}
            >
                Enviar mensagem para todos os jogadores
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            lineHeight: '20px',
                            color: '#292929',
                        }}
                    >
                        Digite um título e uma mensagem para enviar uma
                        notificação push para todos os jogadores.
                    </Typography>

                    <TextField
                        label='Título'
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        fullWidth
                        size='small'
                    />

                    <TextField
                        label='Mensagem'
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        fullWidth
                        multiline
                        minRows={3}
                    />

                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '12px',
                            lineHeight: '18px',
                            color: 'red',
                        }}
                    >
                        Atenção: esta mensagem será enviada para todos os
                        jogadores.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant='outlined'>
                    Cancelar
                </Button>
                <Button
                    onClick={handleSendClick}
                    variant='contained'
                    disabled={sending}
                >
                    {sending ? 'Enviando...' : 'Enviar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BroadcastDialog;
